import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { PricingFeatureList } from "./PricingFeatureList";

interface PricingPlanCardProps {
  title: string;
  description: string;
  price: string;
  period: string;
  features: string[];
  restrictedFeatures?: string[];
  buttonText: string;
  buttonClassName?: string;
  checkColor?: string;
  isBestValue?: boolean;
  onSubscribe: () => void;
}

export const PricingPlanCard = ({
  title,
  description,
  price,
  period,
  features,
  restrictedFeatures = [],
  buttonText,
  buttonClassName = "",
  checkColor = "text-gray-500",
  isBestValue = false,
  onSubscribe,
}: PricingPlanCardProps) => {
  return (
    <Card className={`relative h-full border-2 ${isBestValue ? 'border-amber-500 hover:border-amber-600' : 'hover:border-gray-300'} transition-all`}>
      {isBestValue && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-white px-4 py-1 rounded-full text-sm font-medium">
          Melhor Valor
        </div>
      )}
      <CardHeader className="space-y-2">
        <CardTitle className="text-2xl md:text-3xl">{title}</CardTitle>
        <CardDescription className="min-h-[48px]">{description}</CardDescription>
        <div className="mt-4 flex items-baseline">
          <span className="text-4xl md:text-5xl font-bold">{price}</span>
          <span className="text-gray-600 ml-2">{period}</span>
        </div>
      </CardHeader>
      <CardContent className="flex-grow">
        <PricingFeatureList 
          features={features} 
          restrictedFeatures={restrictedFeatures}
          checkColor={checkColor}
        />
      </CardContent>
      <CardFooter className="pt-6">
        <Button 
          className={`w-full text-base py-6 ${buttonClassName}`}
          onClick={onSubscribe}
        >
          {buttonText}
        </Button>
      </CardFooter>
    </Card>
  );
};